import type {
  HighlightConfig,
  SuperLatexAnnotation,
  SuperLatexConnection,
  SuperLatexLayout,
  SuperLatexNode,
} from '@examdojo/super-latex';
import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, SuperLatexBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertSuperLatexBlockToTiptap = ((block) => {
  return {
    type: 'superLatex',
    attrs: {
      latex_nodes: block.latex_nodes,
      ...(block.annotations && { annotations: block.annotations }),
      ...(block.connections && { connections: block.connections }),
      ...(block.layout && { layout: block.layout }),
      ...(block.highlighted_anchors && { highlighted_anchors: block.highlighted_anchors }),
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
    },
  };
}) satisfies BlockToTiptapConverter<SuperLatexBlock>;

export function convertTiptapToSuperLatexBlock(json: JSONContent): SuperLatexBlock {
  const attrs = json.attrs ?? {};

  return {
    id: uuid(),
    type: ContentBlockType.SuperLatex,
    latex_nodes: (attrs['latex_nodes'] as SuperLatexNode[]) ?? [],
    ...(attrs['annotations'] && { annotations: attrs['annotations'] as SuperLatexAnnotation[] }),
    ...(attrs['connections'] && { connections: attrs['connections'] as SuperLatexConnection[] }),
    ...(attrs['layout'] && { layout: attrs['layout'] as SuperLatexLayout }),
    ...(attrs['highlighted_anchors'] && {
      highlighted_anchors: attrs['highlighted_anchors'] as Record<string, HighlightConfig>,
    }),
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
  };
}
